function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "215347CB-26FD-47C6-8A3B-62319B4C7BA2@3x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.445079985
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Set",
  transform: "translate(-186.000000, -207.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_balance_1352041",
  transform: "translate(186.000000, 207.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.24752,11.790535 L17.2512,11.790535 L19.74912,7.7363595 L22.24752,11.790535 Z M6.7488,11.7971921 L1.75248,11.7971921 L4.2504,7.7430166 L6.7488,11.7971921 Z M15.49872,12.4752655 C15.49872,13.7172907 15.96624,14.8461451 16.72224,15.6659197 C17.49408,16.5037636 18.56496,17.0220666 19.7496,17.0220666 C20.93472,17.0220666 22.0056,16.5037636 22.77744,15.6659197 C23.53248,14.8461451 24,13.7172907 24,12.4752655 L24,12.1400329 L24,12.0154499 L20.33712,6.07113284 L19.74864,5.11726514 L12.67872,5.12011818 L12.67872,3.56045415 C13.23504,3.30272918 13.62,2.74353256 13.62,2.09541607 C13.62,1.20241331 12.88944,0.479166667 11.98848,0.479166667 C11.08656,0.479166667 10.35648,1.20288882 10.35648,2.09541607 C10.35648,2.74400807 10.74144,3.30272918 11.29776,3.56045415 L11.29776,5.12059369 L4.2504,5.12344674 L3.66288,6.07731444 L0.13872,11.7971921 L0,12.022107 L0,12.1638082 L0,12.4814471 C0,13.7234723 0.46752,14.8523267 1.22304,15.6721013 C1.99488,16.5094697 3.06576,17.0282482 4.2504,17.0282482 C5.43552,17.0282482 6.50592,16.5094697 7.27824,15.6721013 C8.03424,14.8523267 8.50128,13.7229968 8.50128,12.4814471 L8.50128,12.1462145 L8.50128,12.0216315 L5.08992,6.48625074 L11.29728,6.4838732 L11.29728,21.1523232 L5.72112,21.1523232 L5.72112,22.5208333 L18.25536,22.5208333 L18.25536,21.1523232 L12.6792,21.1523232 L12.6792,6.48292219 L18.9096,6.48054465 L15.63744,11.7910105 L15.49872,12.016401 L15.49872,12.1585776 L15.49872,12.4752655 Z",
  id: "Shape"
}))));

var SvgBalance = function SvgBalance(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBalance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/balance.bc75e70c.svg";
export { ForwardRef as ReactComponent };